import React from 'react';

const KeyIcon: React.FC<{ size?: number; color?: string }> = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="7.5" cy="15.5" r="3.5" />
    <path d="M10.5 12.5L21 3" />
    <path d="M18.5 5.5l2 2" />
    <path d="M15.5 8.5l2 2" />
  </svg>
);

export default KeyIcon;
